import { Button } from 'antd';
import cls from 'classnames';
import React, { createElement } from 'react';

import { useLocaleComponent } from '../../hooks/use-locale';
import { usePrefixCls } from '../../hooks/use-prefix-cls';

import useStyle from './style';
import config from './type-config';

interface ExceptionProps {
  type?: '403' | '404' | '500';
  title?: React.ReactNode,
  desc?: React.ReactNode;
  img?: string;
  backText?: React.ReactNode;
  actions?: React.ReactNode;
  linkElement?: string | React.ReactElement;
  redirect?: string;
  className?: string;
}

/** Exception 展示带插图、说明与操作区的异常页面。 */
export const Exception = (props: ExceptionProps) => {
  const locale = useLocaleComponent('Exception');
  const prefixCls = usePrefixCls('exception');
  const [wrapSSR, hashId] = useStyle(prefixCls);
  const {
    className,
    type = '500',
    title,
    desc,
    img,
    backText = locale.backHome,
    actions,
    linkElement = 'a',
    redirect = '/',
  } = props;
  const pageType = type in config ? type : '500';
  // undefined 保持原有默认标题，null 允许上层错误组件完整移除标题节点。
  const currentTitle = title === undefined ? `${locale.errorTitle} ${pageType}` : title;
  const defaultDescription = pageType === '403'
    ? locale.forbidden
    : pageType === '404' ? locale.notFound : locale.serverError;
  return wrapSSR(
    <div className={cls(prefixCls, hashId, className)}>
      <div className={`${prefixCls}-imgBlock`}>
        <div
          className={`${prefixCls}-imgEle`}
          style={{ backgroundImage: `url(${img || config[pageType].img})` }}
        />
      </div>
      <div className={`${prefixCls}-content`}>
        {currentTitle === null ? null : <h1>{currentTitle}</h1>}
        <div className={`${prefixCls}-desc`}>{desc || defaultDescription}</div>
        <div className={`${prefixCls}-actions`}>
          {actions
            || createElement(
                linkElement as string | React.ComponentType<{ to: string; href: string }>,
                {
                  to: redirect,
                  href: redirect,
                },
              <Button type="primary">{backText}</Button>,
            )}
        </div>
      </div>
    </div>,
  );
};
